import type { ConnectionState } from "../../lib/styxClient";

export type RelayState = {
  conn: ConnectionState;
  authenticated: boolean;
};

export type RelayAction =
  | { type: "set-conn"; conn: ConnectionState }
  | { type: "set-authenticated"; authenticated: boolean }
  | { type: "reset" };

export function initialRelayState(): RelayState {
  return {
    conn: "disconnected",
    authenticated: false,
  };
}

export function relayReducer(state: RelayState, action: RelayAction): RelayState {
  switch (action.type) {
    case "set-conn":
      return { ...state, conn: action.conn };
    case "set-authenticated":
      return { ...state, authenticated: action.authenticated };
    case "reset":
      return initialRelayState();
    default:
      return state;
  }
}
